import React from 'react'
import { Tabs } from 'antd'
import { useTranslation } from 'react-i18next'
import RestolutionApi from './RestolutionApi'
import { useIntegrationDocsURL } from '../../../../../../utils/docs'
import DimensionMap from '../dimensionMap/DimensionMap'

const Restolution: React.FC = () => {
  const { t } = useTranslation()
  const integrationDocs = useIntegrationDocsURL()

  const items = [
    {
      label: t('integrationsPage:api'),
      key: 'api',
      children: <RestolutionApi />
    },
    {
      label: t('integrationsPage:restaurants'),
      key: 'restaurants',
      children: (
        <DimensionMap
          getDimensionsUrl="/restolution/restaurants/{companyId}"
          updateDimensionsUrl="/restolution/restaurants/{companyId}/{id}"
          dataKey="businessUnitUUID"
        />
      )
    }
  ]

  return (
    <>
      <a href={integrationDocs.external('restolution')} target="_blank" rel="noopener noreferrer">
        {t('header:manual')}
      </a>
      <Tabs items={items} destroyOnHidden />
    </>
  )
}

export default Restolution
